import { AppContext, B1, T2, toast } from '@nile/components';
import { Button, ButtonGroup, Modal } from '@superops/ui-design-system';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ModalTitleWrapper } from './styles';

const DowngradePlan = (props) => {
  const { active, handleClose, subscription } = props;

  const app = useContext(AppContext);

  const { user } = app;

  const onDowngradeHandler = () => {
    const userMeta = {
      email: user.email,
      name: user.name,
      userId: user.userId,
      subscriptionStatus: user.subscriptionStatus,
      currentPlan: subscription?.currentPlanPrice?.plan?.planName,
      billingPeriod: subscription?.billingPeriod,
      licenseCount: subscription?.licenseCount,
      addOnsCount: subscription?.subscribedAddons?.length,
      nextBillingDateTime: dayjs(subscription?.nextBillingDateTime).format(
        'MMM DD, YYYY'
      )
    };
    window.Intercom('trackEvent', 'downgrade-plan', userMeta);
    toast('success', 'Request for plan downgrade placed successfully');
    handleClose(false);
  };
  return (
    <>
      <Modal
        open={active}
        onClose={() => handleClose(false)}
        title={
          <ModalTitleWrapper>
            <div className="modal-title danger">
              <B1>
                <FormattedMessage id="admin.billing.downgraderequest.title" />
              </B1>
            </div>
          </ModalTitleWrapper>
        }
      >
        <Modal.Section>
          <>
            <div className="mt-10">
              <T2>
                <FormattedMessage id="admin.billing.downgraderequest.description" />
              </T2>
            </div>
            <div className="mt-10">
              <B1>
                <FormattedMessage id="admin.billing.downgraderequest.note" />
              </B1>
            </div>
            <div className="mt-20 flex jend">
              <ButtonGroup>
                <Button plain onClick={() => handleClose(false)}>
                  <FormattedMessage id="common.cancel" />
                </Button>
                <Button primary onClick={onDowngradeHandler}>
                  <FormattedMessage id="common.confirm" />
                </Button>
              </ButtonGroup>
            </div>
          </>
        </Modal.Section>
      </Modal>
    </>
  );
};

export default withRouter(DowngradePlan);
